import OpenInNewOutlined from "@mui/icons-material/OpenInNewOutlined";
import { IconButton, Tooltip } from "@mui/material";

/**
 * A report table's Explorer link: the league-wide query the table comes from, under the report's column names, with
 * our rows pinned and the report's ranks. The backend builds it with the report (team_report/explorer_links.py), so
 * it is a plain link (open in a new tab, copy it). Screen only.
 */
export default function ExplorerTableLink({
  href,
  fontSize = "1.265rem",
}: {
  href?: string;
  fontSize?: string;
}) {
  if (!href) return null;
  return (
    <Tooltip title="Open in Explorer" arrow placement="top">
      <IconButton
        component="a"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        size="small"
        aria-label="Open in Explorer"
        sx={{
          p: "2px",
          color: "text.secondary",
          opacity: 0.5,
          "&:hover": { opacity: 1, color: "primary.main" },
          transition: "opacity 0.15s, color 0.15s",
          "@media print": { display: "none" },
        }}
      >
        <OpenInNewOutlined sx={{ fontSize }} />
      </IconButton>
    </Tooltip>
  );
}
